import { failure, inProgress, notAsked, RemoteData, success } from 'ngx-remotedata';
import { DocumentValueActions, DocumentValueActionTypes } from './actions';
import { ErrorWrapper } from '../models/common';

export type DocumentValuesState = RemoteData<string[], ErrorWrapper>;

export function documentValuesReducer(
    state: DocumentValuesState = notAsked(),
    action: DocumentValueActions
): DocumentValuesState {
    switch (action.type) {
        case DocumentValueActionTypes.LOAD_DOCUMENT_VALUES:
            return inProgress([]);
        case DocumentValueActionTypes.LOAD_DOCUMENT_VALUES_SUCCESS:
            return success(action.payload);
        case DocumentValueActionTypes.LOAD_DOCUMENT_VALUES_FAIL:
            return failure(action.payload.error);
        default:
            return state;
    }
}
